export const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_ln5sjdj', // Replace with your service ID
  TEMPLATE_ID: 'template_2dqvvt4', // Replace with your template ID
  PUBLIC_KEY: 'eQCMOZxRDadU8QdH2' // Replace with your public key
}; 